import { screeningRecurrenceSchema } from '../requirements/screening-recurrence.js';
/** Exact controlled forms retained from the approved legacy HR_4.15 mapping. */
const forms = {
    rn: ['HR_4.15A.3', 'HR_4.15J.15'],
    'lpn-lvn': ['HR_4.15A.3', 'HR_4.15J.15'],
    pt: ['HR_4.15B.5', 'HR_4.15N.19'],
    pta: ['HR_4.15C.7', 'HR_4.15N.19'],
    ot: ['HR_4.15G.12', 'HR_4.15K.16'],
    cota: ['HR_4.15H.13', 'HR_4.15K.16'],
    slp: ['HR_4.15D.9', 'HR_4.15L.17'],
    msw: ['HR_4.15E.10', 'HR_4.15M.18'],
    hha: ['HR_4.15I.14', 'HR_4.15O.20'],
};
/** Starting values only; saved agency settings replace these for runtime decisions. */
export const defaultCompetencyRoleForms = Object.entries(forms).map(([jobProfileKey, [initialFormId, ongoingFormId]]) => ({ jobProfileKey, initialFormId, ongoingFormId }));
export const defaultCompetencyRequirementMappings = [
    { requirementKey: 'initial-competency-before-independent-care', assessmentType: 'initial', jobProfileKeys: Object.keys(forms) },
    { requirementKey: 'hha-initial-onsite-competency', assessmentType: 'initial', jobProfileKeys: ['hha'] },
    { requirementKey: 'ongoing-competency-triennial', assessmentType: 'ongoing', jobProfileKeys: Object.keys(forms) },
    { requirementKey: 'hha-annual-onsite-competency', assessmentType: 'ongoing', jobProfileKeys: ['hha'] },
];
/** Live Compliance manual, revised August 2026: LD 7.25.7 clauses 13–14; HR 4.8.1. */
export const defaultScreeningRecurrence = [
    screeningRecurrenceSchema.parse({
        requirementKey: 'oig-leie-exclusion-check',
        expiry: { mode: 'calendar-months', everyMonths: 1, alignment: 'calendar-period', reminderTierDays: [7, 1] },
        policyReference: 'LD 7.25.7 clause 13, revised August 2026: monthly government sanctions screening, including OIG.',
    }),
    screeningRecurrenceSchema.parse({
        requirementKey: 'nsopw-sex-offender-check',
        expiry: { mode: 'calendar-months', everyMonths: 6, alignment: 'same-day' },
        policyReference: 'LD 7.25.7 clause 14 and HR 4.8.1, revised August 2026: before hire and at least every six months.',
    }),
];
//# sourceMappingURL=settings.seed.js.map